//import Vue from "vue";
import * as gtypes from "../../generic/mtypes";
import * as types from "./mtypes";

export default {
  //Get Accounts
  [types.FETCH_ROLES_REQUEST](state) {
    state.fetching = true;
    state.error = null;
  },

  [types.FETCH_ALL_ROLES_SUCCESS](state, result) {
    state.fetching = false;
    state.loading = false;
    state.allRolesResponse = result;
  },

  [types.FETCH_ROLES_SUCCESS](state, result) {
    state.fetching = false;
    state.loading = false;
    Object.assign(state.rolesResponse, result);
  },

  [types.FETCH_ONE_ROLE_SUCCESS](state, result) {
    state.fetching = false;
    state.error = null;
    state.role = result.data;
    state.totalRecords = result.totalRecords;
    state.pageSize = result.pageSize;
    state.currentPage = result.currentPage;
  },

  [types.FETCH_ALL_PERMISSIONS_FAILURE](state, error) {
    state.fetching = false;
    state.error = error;
    state.permissionList = [];
  },

  [types.FETCH_ALL_PERMISSIONS_SUCCESS](state, result) {
    state.fetching = false;
    state.error = null;
    state.permissionList = result.data;
    state.totalRecords = result.totalRecords;
    state.pageSize = result.pageSize;
    state.currentPage = result.currentPage;
  },

  [types.FETCH_ROLES_FAILURE](state, error) {
    state.fetching = false;
    state.error = error;
    state.rolesList = [];
  },

  [gtypes.REQUEST_HANDLER](state) {
    state.loading = true;
  },

  [gtypes.REQUEST_SUCCESS](state, data) {
    state.loading = false;
    state.isSucceeded = data.succeeded;
    state.resultMessage = data.resultMessage;
  },

  [gtypes.REQUEST_FAILURE](state, data) {
    state.loading = false;
    state.isSucceeded = data.Succeeded;
    state.errorCode = data.ErrorCode;
    state.errorMessage = data.ErrorMessage;
    state.validationErrors = data.ValidationErrors;
  },
};
